<template>
  <div class="container">
    <div class="header" id="home">
      <div class="main" style="min-width: 500px">
        <img class="logo-img" alt="storeel" src="../assets/img/web/header/header-logo@2x.png" />
        <div class="other-item">
          <div>
            <a href="#home">Home</a>
          </div>
          <div>
            <a href="#aboutus">About Us</a>
          </div>
          <div>
            <a href="#create">Create</a>
          </div>
          <div>
            <a href="#contact">Contact</a>
          </div>
          
        </div>
      </div>
      <div class="work-with-us-container">
         <a href="https://canvas.storeel.com" target="_blank" class="canvas-link">canvas</a>
            <a href="mailto:support@storeel.com" target="_blank" rel="noopener noreferrer" class="work-with-us">Work With Us!</a>
          </div>
    </div>
    <div class="banner">
      <!--      <div class="start-video" id="start-video">-->
      <!--        <div class="video-container">-->
      <!--          <video id="video-tag" muted autoplay src="https://cdn2.storeel.app/videos/drama/trailers/888/20251128/c7559fd1cc3e11f0a85876ace6005471.mp4" type="video/mp4"></video>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="banner-container">
        <div class="banner-dramas drama-img-1">
          <img src="../assets/img/web/banner/banner-drama-1.png" alt="" />
        </div>
        <div class="banner-dramas drama-img-2">
          <img src="../assets/img/web/banner/banner-drama-2.png" alt="" />
        </div>
        <div class="banner-dramas drama-img-3">
          <img src="../assets/img/web/banner/banner-drama-3.png" alt="" />
        </div>
        <div class="banner-slogan">
          <img src="../assets/img/web/banner/slogan@2x.png" alt="" />
        </div>
        <div class="banner-dramas drama-img-4">
          <img src="../assets/img/web/banner/banner-drama-4.png" alt="" />
        </div>
        <div class="banner-dramas drama-img-5">
          <img src="../assets/img/web/banner/banner-drama-5.png" alt="" />
        </div>
        <div class="banner-dramas drama-img-6" style="">
          <img src="../assets/img/web/banner/banner-drama-6.png" alt="" />
        </div>
        <div class="banner-desc">
          StoReel is where creators shape the future of storytelling. From diverse narratives to
          interactive worlds, we bring creators and audiences together to experience stories that
          move — and evolve.
        </div>
      </div>
      <div class="download" id="app-download">
        <div class="download-item">
          <img class="download-img" src="../assets/img/web/store/download-ios@2x.png" alt="ios" />
          <div class="scan-code">
            <img src="../assets/img/web/ios.png" alt="ios" />
          </div>
        </div>
        <div class="download-item">
          <img
            class="download-img"
            src="../assets/img/web/store/download-android@2x.png"
            alt="ios"
          />
          <div class="scan-code">
            <img src="../assets/img/web/android.png" alt="ios" />
          </div>
        </div>
      </div>
    </div>
    <div class="content-video" ref="heroVideoSectionRef">
      <!--      <img style="width: 100%; height: 100%;" src="../assets/img/web/content/content-video@2x.png" alt="" />-->
      <video
        muted
        autoplay
        loop
        playsinline
        preload="none"
        :src="heroVideoLoaded ? HERO_VIDEO_SRC : undefined"
      ></video>
      <div class="video-text" id="fadeIn" style="animation-duration: 3s">
        Powered by your imagination.<br />
        Designed for a world that never stops telling stories.
      </div>
    </div>
    <div class="content2" id="aboutus">
      <img src="../assets/img/web/content/content2-logo.png" alt="" />
      <div class="title">We’re building the world’ s next storytelling ecosystem.</div>
      <div class="description">
        <div class="description-item">
          StoReel was born from a simple idea — stories should reflect more voices, travel farther,
          and connect deeper.
        </div>
        <div class="description-item">
          Built by filmmakers, technologists, and dreamers, StoReel is reimagining how creators and
          audiences experience storytelling. Our platform brings together the creative freedom of
          independent filmmaking with the reach and immediacy of digital culture — turning every
          story into a living, evolving world.
        </div>
        <div class="description-item">
          From cinematic series to interactive experiences, StoReel empowers creators everywhere to
          produce, share, and grow stories that audiences can feel, follow, and shape. Together,
          we’re not just watching the future of entertainment — we’re making it.
        </div>
      </div>
    </div>
    <div class="border"></div>
    <div class="content-carousel">
      <div class="content-carousel-container" id="carousel-container">
        <div class="carousel-item" v-for="item in carouseList" :key="item.id">
          <img :src="item.url" alt="" />
        </div>
      </div>
    </div>
    <div class="content-download">
      <div class="download" style="display: flex; justify-content: center">
        <div class="download-item">
          <img class="download-img" src="../assets/img/web/store/download-ios@2x.png" alt="ios" />
          <div class="scan-code">
            <img src="../assets/img/web/ios.png" alt="ios" />
          </div>
        </div>
        <div class="download-item">
          <img
            class="download-img"
            src="../assets/img/web/store/download-android@2x.png"
            alt="ios"
          />
          <div class="scan-code">
            <img src="../assets/img/web/android.png" alt="ios" />
          </div>
        </div>
      </div>
    </div>
    <div class="content-video" ref="secondVideoSectionRef">
      <div class="video-text">Unleash your story. Shape the future of next-gen storytelling.</div>
      <!--      <img src="../assets/img/web/content/content-video-2@2x.png" style="width: 100%; height: 100%" alt="content-video" />-->
      <video
        muted
        autoplay
        loop
        playsinline
        preload="none"
        :src="secondVideoLoaded ? SECOND_VIDEO_SRC : undefined"
      ></video>
    </div>
    <div class="content3">
      <img class="top-img" src="../assets/img/web/content/content3-logo.png" alt="" />
      <div class="title" id="create">
        StoReel empowers creators everywhere to turn imagination into impact.<br />
        We provide the support, data, and global audience to bring bold ideas to life and build
        stories that move the world.
      </div>
      <div class="items">
        <div class="item">
          <div class="item-title">Create</div>
          <img
            class="item-icon item-icon-logo"
            src="../assets/img/web/content/item-logo@2x.png"
            alt=""
          />
          <img
            class="item-icon item-icon-create"
            src="../assets/img/web/content/create-icon.png"
            alt=""
          />
          <div class="item-line"></div>
          <div class="item-desc">
            Use ready-to-produce templates and creative assets to build your next hit faster.
          </div>
        </div>
        <div class="item">
          <div class="item-title">Monetize</div>
          <img
            class="item-icon item-icon-logo"
            src="../assets/img/web/content/item-logo@2x.png"
            alt=""
          />
          <img
            class="item-icon item-icon-create"
            src="../assets/img/web/content/money-icon.png"
            alt=""
          />
          <div class="item-line"></div>
          <div class="item-desc">
            Access funding, co-production, and revenue-sharing opportunities with transparent data
            insights.
          </div>
        </div>
        <div class="item">
          <div class="item-title">Grow</div>
          <img
            class="item-icon item-icon-logo"
            src="../assets/img/web/content/item-logo@2x.png"
            alt=""
          />
          <img
            class="item-icon item-icon-create"
            src="../assets/img/web/content/grow-icon.png"
            alt=""
          />
          <div class="item-line"></div>
          <div class="item-desc">
            Reach global audiences through cross-platform marketing, algorithmic discovery, and
            localized distribution.
          </div>
        </div>
      </div>
      <div class="how-work">
        How it works:<br />
        We Collaborate. You Create.
      </div>
      <div class="how-work-items">
        <div class="how-work-item">
          <div class="how-work-item-title">
            <img
              class="title-bg"
              src="../assets/img/web/content/how-work-item-title-bg.png"
              alt=""
            />
            <img
              class="title-index"
              src="../assets/img/web/content/how-work-item-title-index1.png"
              alt=""
            />
            <span>Concept & Develop</span>
          </div>
          <div class="how-work-item-subtitle">
            Bring your own idea — or start with one of StoReel’s proven story formulas.
          </div>
          <div class="how-work-item-desc">
            We’ll help you refine your concept and prepare it for production through script
            guidance, creative input, and data-backed insights.
          </div>
        </div>
        <div class="how-work-item">
          <div class="how-work-item-title">
            <img
              class="title-bg"
              src="../assets/img/web/content/how-work-item-title-bg.png"
              alt=""
            />
            <img
              class="title-index"
              src="../assets/img/web/content/how-work-item-title-index2.png"
              alt=""
            />
            <span>Co-Produce & Launch</span>
          </div>
          <div class="how-work-item-subtitle">
            Partner with StoReel’s creative and technical teams to produce your series — from
            live-action to AI-enhanced storytelling.
          </div>
          <div class="how-work-item-desc">
            Together, we’ll bring your story to life and share it with a global audience across
            platforms.
          </div>
        </div>
        <div class="how-work-item">
          <div class="how-work-item-title">
            <img
              class="title-bg"
              src="../assets/img/web/content/how-work-item-title-bg.png"
              alt=""
            />
            <img
              class="title-index"
              src="../assets/img/web/content/how-work-item-title-index3.png"
              alt=""
            />
            <span>Monetize & Scale</span>
          </div>
          <div class="how-work-item-subtitle">
            Earn through revenue sharing, brand partnerships, and fan engagement.
          </div>
          <div class="how-work-item-desc">
            Every project can grow into lasting IP — expanding into worlds, characters, and stories
            that keep evolving.
          </div>
        </div>
      </div>
    </div>
    <div class="content4">
      <!--      <div class="bg-black-l"></div>-->
      <div
        id="content4-c"
        style="width: 100%; height: 100%; position: relative; display: flex; align-items: center"
      >
        <div class="drama" v-for="item in content4Imgs" :key="item.id">
          <img :src="item.url" alt="" />
        </div>
      </div>
      <!--      <div class="bg-black-r"></div>-->
    </div>
    <div class="empty-container">
      <div class="bg-black-l"></div>
      <div class="bg-black-r"></div>
    </div>
    <div class="content-download">
      <div class="download" style="display: flex; justify-content: center">
        <div class="download-item">
          <img class="download-img" src="../assets/img/web/store/download-ios@2x.png" alt="ios" />
          <div class="scan-code">
            <img src="../assets/img/web/ios.png" alt="ios" />
          </div>
        </div>
        <div class="download-item">
          <img
            class="download-img"
            src="../assets/img/web/store/download-android@2x.png"
            alt="ios"
          />
          <div class="scan-code">
            <img src="../assets/img/web/android.png" alt="ios" />
          </div>
        </div>
      </div>
    </div>
    <div class="content-video-imgs">
      <div class="content-video-img-text">
        <div class="content-video-img-title">
          StoReel’s<br />
          Creator Support System
        </div>
        <div class="content-video-img-sub">We are here to help your creativity thrive.</div>
        <div class="content-video-img-desc">
          Whether you’re a solo creator, a small studio, or a filmmaker exploring new formats,
          StoReel provides end-to-end support — from story development to global reach.
        </div>
      </div>
      <swiper
        class="swiper-container"
        :slides-per-view="1"
        :space-between="0"
        :modules="modules"
        :loop="true"
        :autoplay="{
          delay: 2000,
          disableOnInteraction: false,
        }"
        navigation
      >
        <swiper-slide v-for="item in videoImgs" :key="'video-img-' + item.id">
          <img class="img-item" :src="item.url" />
        </swiper-slide>
      </swiper>
      <!--      <div style="display: flex;flex-wrap: nowrap;position: absolute; left: 0;" id="video-img-carousel">-->
      <!--        <img v-for="img in videoImgs" :src="img.url" :key="'v-img-' + img.id" class="video-img" alt="video" />-->
      <!--      </div>-->
    </div>
    <div class="content-drama-example">
      <div class="drama-block-row">
        <div class="drama-block">
          <div class="text-title">Data-Driven Insights</div>
          <div class="text-desc">
            Real-time feedback and viewership analytics help you improve and scale.
          </div>
        </div>
        <div class="drama-block">
          <img src="../assets/img/web/content/drama-block-img2.png" alt="" />
        </div>
      </div>
      <div class="drama-block-row margin-top">
        <div class="drama-block">
          <img src="../assets/img/web/content/drama-block-img1.png" alt="" />
        </div>
        <div class="drama-block">
          <div class="text-title text-left">Production Templates</div>
          <div class="text-desc text-left">
            Pre-tested scripts, AI-ready workflows, and creative frameworks for faster execution.
          </div>
        </div>
      </div>
      <div class="drama-block-row margin-top">
        <div class="drama-block">
          <div class="text-title">Marketing Power</div>
          <div class="text-desc">Cross-platform exposure on TikTok, Instagram, and YouTube.</div>
        </div>
        <div class="drama-block">
          <img src="../assets/img/web/content/drama-block-img3.png" alt="" />
        </div>
      </div>
      <div class="drama-block-row margin-top">
        <div class="drama-block">
          <img src="../assets/img/web/content/drama-block-img4.png" alt="" />
        </div>
        <div class="drama-block">
          <div class="text-title text-left">Community & Mentorship</div>
          <div class="text-desc text-left">
            Connect with other creators, exchange feedback, and grow together.
          </div>
        </div>
      </div>
    </div>
    <div class="content-comm">
      A global creative community where stories, creators, and audiences grow together.
    </div>
    <div class="content3">
      <img class="top-img" src="../assets/img/web/content/content3-logo2.png" alt="" />
      <div class="second-title">
        StoReel isn’t just a platform — it’s a living community of storytellers and fans shaping the
        future together.
      </div>
      <div class="second-desc">
        Here, creators inspire each other, audiences become collaborators, and stories evolve
        through real connection and shared imagination.
      </div>
    </div>
    <div class="content-drama-imgs">
      <div class="top-block">
        <div class="top-block-content">
          <div class="block-title">
            Every character you create becomes part of a lasting IP — one you can continue to
            manage, expand, and develop into new worlds, stories, and experiences.
          </div>
          <div class="block-desc">
            On StoReel, creation doesn’t end when the story fades to black — it lives, grows, and
            belongs to you.
          </div>
          <img src="../assets/img/web/content/content-dram-imgs-logo@2x.png" alt="" />
        </div>
      </div>
      <div class="img-container">
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-1.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-2.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-3.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-4.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-5.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-6.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-7.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-1.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-2.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-3.png" alt="" />
        </div>
      </div>
      <div class="img-container" style="margin-left: -100px; width: 120%">
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-21.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-22.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-23.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-24.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-25.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-26.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-27.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-28.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-21.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-22.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-23.png" alt="" />
        </div>
      </div>
      <div class="img-container">
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-31.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-32.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-33.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-34.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-35.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-36.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-37.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-31.png" alt="" />
        </div>
        <div class="img-container-item">
          <div class="mask"></div>
          <img src="../assets/img/web/content/content-dram-imgs-32.png" alt="" />
        </div>
      </div>
    </div>
    <div class="content-download" style="position: relative; z-index: 111">
      <div class="download" style="display: flex; justify-content: center">
        <div class="download-item">
          <img class="download-img" src="../assets/img/web/store/download-ios@2x.png" alt="ios" />
          <div class="scan-code">
            <img src="../assets/img/web/ios.png" alt="ios" />
          </div>
        </div>
        <div class="download-item">
          <img
            class="download-img"
            src="../assets/img/web/store/download-android@2x.png"
            alt="ios"
          />
          <div class="scan-code">
            <img src="../assets/img/web/android.png" alt="ios" />
          </div>
        </div>
      </div>
    </div>
    <div class="faq-container">
      <div class="faq-container-title">FAQ</div>
      <div class="faq-container-subtitle">Answers for creators</div>
      <div class="faq-container-desc">
        Explore the most common questions about interactive storytelling, Al-poweld creation, and
        joining our global content community.
      </div>
      <div class="question-item" :key="'faq-' + index" v-for="(item, index) in questions">
        <div class="question-title" @click="() => faqClick(index)">
          {{ item.question }}
          <span :class="'question-add ' + (currentfaqIndex === index ? 'icon-open' : '')">+</span>
        </div>
        <div :class="'question-answer ' + (currentfaqIndex === index ? 'faq-show' : 'faq-hid')">
          {{ item.answer }}
        </div>
      </div>
    </div>
    <div class="contact-us" id="contact">
      <div class="contact-title">Contact</div>
      <div class="terms">
        <a href="/user-agreement">Terms of Service</a>
      </div>
      <div class="terms">
        <a href="/privacy">Privacy Policy</a>
      </div>
      <div class="terms">
        <a href="/vip-service-agreement">VIP Service Agreement</a>
      </div>
      <div class="terms">
        <a href="mailto:creator@storeel.com" class="support" target="_blank" rel="noopener noreferrer">creator@storeel.com</a>
      </div>
      <div class="terms">
        <a href="mailto:support@storeel.com" class="support" target="_blank" rel="noopener noreferrer">support@storeel.com</a>
      </div>
      <div class="terms">
        <a href="mailto:bd@storeel.com" class="support" target="_blank" rel="noopener noreferrer">bd@storeel.com</a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import img0 from '../assets/img/web/content/carousel1.png'
import img1 from '../assets/img/web/content/carousel2.png'
import img2 from '../assets/img/web/content/carousel3.png'
import img3 from '../assets/img/web/content/carousel4.png'
import img4 from '../assets/img/web/content/carousel5.png'
import img5 from '../assets/img/web/content/carousel6.png'

import videoImg1 from '../assets/img/web/content/video-img-1.png'
import videoImg2 from '../assets/img/web/content/video-img-2.png'
import videoImg3 from '../assets/img/web/content/video-img-3.png'
import videoImg4 from '../assets/img/web/content/video-img-4.png'
import videoImg5 from '../assets/img/web/content/video-img-5.png'
import videoImg6 from '../assets/img/web/content/video-img-6.png'

import content4Img1 from '../assets/img/web/content/content4-drama-1.png'
import content4Img2 from '../assets/img/web/content/content4-drama-2.png'
import content4Img3 from '../assets/img/web/content/content4-drama-3.png'
import content4Img4 from '../assets/img/web/content/content4-drama-4.png'
import content4Img5 from '../assets/img/web/content/content4-drama-5.png'
import content4Img6 from '../assets/img/web/content/content4-drama-6.png'
import content4Img7 from '../assets/img/web/content/content4-drama-7.png'
import content4Img8 from '../assets/img/web/content/content4-drama-8.png'
import content4Img9 from '../assets/img/web/content/content4-drama-9.png'
import content4Img10 from '../assets/img/web/content/content4-drama-10.png'
import content4Img11 from '../assets/img/web/content/content4-drama-11.png'

// const props = defineProps(['dramas'])
//
// const scrollToTop = () => {
//   document.getElementById("container-body")!.scrollTop = 0;
// };

// const expandPage = () => {
//   const dom = document.getElementById('expand-icon')!
//   if (dom.classList.contains('expand-icon-open')) {
//     document.getElementById('drama-items')!.style.height = '800px'
//   } else {
//     document.getElementById('drama-items')!.style.height = '1200px'
//   }
//   dom.classList.toggle('expand-icon-open')
// }
import { onMounted, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules'
const HERO_VIDEO_SRC =
  'https://cdn2.storeel.app/videos/clips/video/888/20251201/24f04f94cea511f0923d4a9be5f1ac92.mp4'
const SECOND_VIDEO_SRC =
  'https://cdn2.storeel.app/videos/clips/video/888/20251201/323568c8cea511f0923d4a9be5f1ac92.mp4'

const heroVideoSectionRef = ref<HTMLElement | null>(null)
const secondVideoSectionRef = ref<HTMLElement | null>(null)
const heroVideoLoaded = ref(false)
const secondVideoLoaded = ref(false)

const currentfaqIndex = ref(-1)
const modules = [Navigation, Pagination, A11y, Autoplay]

//基准大小
const baseSize = 16
let fontSize = 16
//设置 rem 函数
function setRem() {
  //当前页面宽度相对于1920宽的缩放比例, 可根据自己需要修改
  const scale = document.documentElement.clientWidth / 1920
  //设置页面根节点字体大小, 字体大小最小为12
  fontSize = baseSize * Math.min(scale, 2) > 12 ? baseSize * Math.min(scale, 2) : 12
  document.documentElement.style.fontSize = fontSize + 'px'
}

//初始化
setRem()
//改变窗口大小重新设置rem
window.onresize = function () {
  setRem()
}

const faqClick = (index: number) => {
  if (currentfaqIndex.value === index) {
    currentfaqIndex.value = -1
    return
  }
  currentfaqIndex.value = index
}
const questions = ref([
  {
    question: 'Who can become a StoReel creator?',
    answer:
      'StoReel works with filmmakers, writers, studios, and emerging Al creators who understand storytelling and want to explore new ways to create. If you have experience or passion in visual storytelling - whether through film, production, or creative writing - you can be part of our creator network.',
  },
  {
    question: 'Do I need to know how to use Al tools?',
    answer:
      'Not necessarily. Many of our creators come from traditional filmmaking backgrounds. StoReel provides creative support, tutorials, and access to our in-house Al resources - helping you blend cinematic craft with cutting-edge tools.',
  },
  {
    question: 'What kinds of stories work best on StoReel?',
    answer:
      'We focus on emotionally engaging, high-concept stories - often in genres like romance, mystery, fantasy, or thriller. Fast-paced, character-driven storytelling with strong emotional hooks.',
  },
  {
    question: 'How do creators earn on StoReel?',
    answer:
      'Creators can earn through co-production deals, revenue sharing, and brand collaborations. StoReel also helps top creators build long-term value through character-based IP that can evolve across multiple stories or formats.',
  },
  {
    question: 'Who owns the stories or characters I create?',
    answer:
      'You maintain ownership of your original stories and characters. StoReel helps you grow that IP, expand its world, and connect it with fans - so your work lives beyond a single project.',
  },
])

const carouseList = ref([
  { id: 'carouse1', url: img0 },
  { id: 'carouse2', url: img1 },
  { id: 'carouse3', url: img2 },
  { id: 'carouse4', url: img3 },
  { id: 'carouse5', url: img4 },
  { id: 'carouse6', url: img5 },
  { id: 'carouse7', url: img0 },
  { id: 'carouse8', url: img1 },
  { id: 'carouse9', url: img2 },
  { id: 'carouse10', url: img3 },
])

const content4Imgs = ref([
  { id: 'content4-carouse1', url: content4Img1 },
  { id: 'content4-carouse2', url: content4Img2 },
  { id: 'content4-carouse3', url: content4Img3 },
  { id: 'content4-carouse4', url: content4Img4 },
  { id: 'content4-carouse5', url: content4Img5 },
  { id: 'content4-carouse6', url: content4Img6 },
  { id: 'content4-carouse7', url: content4Img7 },
  { id: 'content4-carouse8', url: content4Img8 },
  { id: 'content4-carouse9', url: content4Img9 },
  { id: 'content4-carouse10', url: content4Img10 },
  { id: 'content4-carouse11', url: content4Img11 },
  { id: 'content4-carouse111', url: content4Img1 },
  { id: 'content4-carouse112', url: content4Img2 },
  { id: 'content4-carouse113', url: content4Img3 },
  { id: 'content4-carouse114', url: content4Img4 },
  { id: 'content4-carouse115', url: content4Img5 },
  { id: 'content4-carouse116', url: content4Img6 },
  { id: 'content4-carouse117', url: content4Img7 },
  { id: 'content4-carouse118', url: content4Img8 },
  { id: 'content4-carouse119', url: content4Img9 },
  { id: 'content4-carouse1110', url: content4Img10 },
  { id: 'content4-carouse1111', url: content4Img11 },
])

const videoImgs = ref([
  { id: 'carouse1', url: videoImg1 },
  { id: 'carouse2', url: videoImg2 },
  { id: 'carouse3', url: videoImg3 },
  { id: 'carouse4', url: videoImg4 },
  { id: 'carouse5', url: videoImg5 },
  { id: 'carouse6', url: videoImg6 },
])

let count = 0
const startCarousel = () => {
  setInterval(() => {
    count += 1
    const rem = Math.round((318 / baseSize) * fontSize)
    if (count >= rem) {
      const temp = carouseList.value
      const first = temp.splice(0, 1)
      temp.push(first[0])
      carouseList.value = temp
      count = 0
    }
    ;(document.querySelector('#carousel-container')! as HTMLElement).style.left = -count + 'px'
  }, 10)
  let count2 = 0
  setInterval(() => {
    count2 += 1
    const rem2 = Math.round((580 / baseSize) * fontSize)
    if (count2 >= rem2) {
      const temp = content4Imgs.value
      const first = temp.splice(0, 1)
      temp.push(first[0])
      content4Imgs.value = temp
      count2 = 0
    }
    ;(document.querySelector('#content4-c')! as HTMLElement).style.left = -count2 + 'px'
  }, 10)
}
const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * max)
}
const startImgsHover = () => {
  const old = document.getElementsByClassName('img-hover')[0]
  if (old) {
    old.classList.remove('img-hover')
  }
  const row = getRandomInt(3)
  const col = getRandomInt(7)
  const rowEl = document.getElementsByClassName('img-container')[row]
  rowEl.getElementsByClassName('img-container-item')[col].classList.add('img-hover')
}

const textFadeIn = () => {
  const element = document.getElementById('fadeIn')
  if (!element) return

  const rect = element.getBoundingClientRect()
  const viewportHeight = window.innerHeight
  const isVisible = rect.top >= 0 && rect.bottom <= viewportHeight

  if (isVisible) {
    document.getElementById('fadeIn')!.classList.add('animate__animated', 'animate__fadeIn')
  } else {
    document.getElementById('fadeIn')!.classList.remove('animate__animated', 'animate__fadeIn')
  }
}

const initializedLazyImages = new WeakSet<HTMLImageElement>()

const setupImageLazyLoading = () => {
  const processImages = (observer?: IntersectionObserver) => {
    const images = document.querySelectorAll('img')
    images.forEach((img) => {
      if (initializedLazyImages.has(img)) return
      // Keep first-screen images eager to avoid visible pop-in.
      if (img.closest('.header') || img.closest('.banner')) return

      const currentSrc = img.getAttribute('src')
      if (!currentSrc || currentSrc.startsWith('data:')) return

      img.setAttribute('loading', 'lazy')
      img.setAttribute('decoding', 'async')
      img.setAttribute('data-src', currentSrc)
      img.removeAttribute('src')

      if (observer) {
        observer.observe(img)
      } else {
        // Fallback for very old browsers without IntersectionObserver.
        img.setAttribute('src', currentSrc)
      }

      initializedLazyImages.add(img)
    })
  }

  if (!('IntersectionObserver' in window)) {
    processImages()
    return
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        const img = entry.target as HTMLImageElement
        const dataSrc = img.getAttribute('data-src')
        if (dataSrc && !img.getAttribute('src')) {
          img.setAttribute('src', dataSrc)
        }
        observer.unobserve(img)
      }
    },
    {
      root: null,
      threshold: 0.01,
      rootMargin: '300px 0px',
    },
  )

  processImages(observer)
  // Re-apply for async-rendered nodes (e.g. Swiper clones).
  setTimeout(() => processImages(observer), 800)
  setTimeout(() => processImages(observer), 2000)
}

onMounted(() => {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue
          if (entry.target === heroVideoSectionRef.value) {
            heroVideoLoaded.value = true
            observer.unobserve(entry.target)
          }
          if (entry.target === secondVideoSectionRef.value) {
            secondVideoLoaded.value = true
            observer.unobserve(entry.target)
          }
        }
      },
      {
        root: null,
        // Load only when a meaningful portion is visible.
        threshold: 0.35,
        rootMargin: '0px',
      },
    )

    if (heroVideoSectionRef.value) observer.observe(heroVideoSectionRef.value)
    if (secondVideoSectionRef.value) observer.observe(secondVideoSectionRef.value)
  } else {
    // Fallback for very old browsers.
    heroVideoLoaded.value = true
    secondVideoLoaded.value = true
  }

  window.addEventListener(
    'scroll',
    () => {
      textFadeIn()
    },
    true,
  )

  // Delay non-critical image requests until near viewport.
  setupImageLazyLoading()

  startCarousel()

  setInterval(() => {
    startImgsHover()
  }, 1500)

  const doms = document.getElementsByClassName('banner-dramas')
  const leng = doms.length
  setInterval(() => {
    for (let i = 0; i < leng; i++) {
      doms
        .item(i)
        ?.classList.add(
          'animate__animated',
          'animate__headShake',
          'animate__infinite',
          'animate__slow',
        )
    }
    setTimeout(() => {
      for (let i = 0; i < leng; i++) {
        doms
          .item(i)
          ?.classList.remove('animate__animated', 'animate__headShake', 'animate__infinite')
      }
    }, 500)
  }, 5000)
})
document.getElementsByTagName('html')[0].style.minWidth = '1366px'
document.body.style.minWidth = '1366px'
</script>

<style scoped>
@import '@/assets/css/web/index.css';

.policy-item {
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  margin-right: 1rem;
}

.policy-item:hover {
  text-decoration: underline;
}
</style>
